// @ts-nocheck
export const Types = {
  ILanguageService: Symbol.for('ILanguageService'),
  IRouterGateway: Symbol.for('IRouterGateway'),
  IServiceGateway: Symbol.for('IServiceGateway'),
  IStorageGateway: Symbol.for('IStorageGateway'),
  IUIHostGateway: Symbol.for('IUIHostGateway'),
  IWebSocketGateway: Symbol.for('IWebSocketGateway')
}
